import { Link } from 'react-router-dom';
import { articlesData } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';

export default function LatestArticles() {
  const latestArticles = articlesData.slice(0, 3);

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新文章
            </h2>
            <p className="mt-2 text-foreground-600 text-sm">
              深度影评、观影指南与幕后故事
            </p>
          </div>
          <Link
            to="/article/1"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} {...article} />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/article/1"
            className="inline-flex items-center gap-1.5 text-primary-500 hover:text-primary-600 font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}